export default "__VITE_ASSET__713482cc__"